import React from 'react'
import { PlayersLoader, PlayerLoader } from 'loaders'
import PropTypes from 'prop-types'
import PlayerDashboardContainer from './PlayerDashboardContainer'

const PlayerDashboard = ({
  history,
  match: {
    params: { playerId },
  },
  match,
}) => (
  // @todo check why we needed this PlayersLoader here in Player Dashboard
  <PlayersLoader alwaysRenderChildren passIsLoading>
    <PlayerLoader
      playerId={playerId}
      additionalFields={[
        'avatar',
        'sequences',
        'statistics',
        'journal',
        'logo',
      ]}
    >
      <PlayerDashboardContainer
        playerId={playerId}
        history={history}
        match={match}
      />
    </PlayerLoader>
  </PlayersLoader>
)

PlayerDashboard.propTypes = {
  history: PropTypes.shape({
    push: PropTypes.func.isRequired,
  }).isRequired,
  match: PropTypes.shape({
    params: PropTypes.shape({
      playerId: PropTypes.string.isRequired,
    }).isRequired,
  }).isRequired,
}

export default PlayerDashboard
